export const colors = {
  brandColor: `#4996E9`,
  accentColor: `#45CB85`,
  titleColor: `#191919`,
  inputTextColor: `#191919`,
  subtitleColor: `#575757`,
  placeholderText: `#959595`,
  chevronColor: `#c2c2c2`,
  lineBreak: `#eaeaea`,
  inputBackground: `#F5F5F5`,
  cancel: `#EB6262`,
  starterPlan: '#ffa54b',
  premiumPlan: '#34cb7f',
  proPlan: '#9a52ff',
};

export const textSizes = {
  title: `28px`,
  subtitle: `18px`,
  intermediate: `14px`,
  normal: `12px`,
};

export const boxStyles = {
  boxShadow: `2px 2px 10px #00000024`,
  // boxShadow: '0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);',
  borderRadius: `8px`,
  standardPadding: `12px`,
  desktopPadding: `20px`,
  desktopBreak: `550px`,
};
